<div style="height:calc(100vh - 112px); overflow-y: auto;">
  <div class="container-fluid">
    <div class="row justify-content-center pt-4">
      <div class="col-11">
        <div class="table-container">
          <div class="row table-inner-container">
            <div class="table-inner-inner-container">
              <table mat-table [dataSource]="dataSource" [multiTemplateDataRows]="true" matSort
                     (matSortChange)="sortData($event)">
                <!-- Search Header -->
                <ng-container matColumnDef="table-name">
                  <th colspan="3" mat-header-cell *matHeaderCellDef>
                    <span style="font-size: large;">SMS Notifications</span>
                  </th>
                </ng-container>
                <!-- Search Header -->
                <ng-container matColumnDef="search-header">
                  <th colspan="2" mat-header-cell *matHeaderCellDef>
                    <form>
                      <mat-form-field style="width: 100%;">
                        <mat-label>Search</mat-label>
                        <input type="text" matInput (keyup)="applyFilter($event)" #input>
                        <mat-icon matSuffix>search</mat-icon>
                      </mat-form-field>
                    </form>
                  </th>
                </ng-container>
                <!-- COLUMN -->
                <ng-container matColumnDef="time">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="time"> Date</th>
                  <td mat-cell
                      *matCellDef="let element" style="padding: 5px;">
                    {{ element.notification.timestamp | date: 'medium' }}
                  </td>
                </ng-container>
                <!-- COLUMN -->
                <ng-container matColumnDef="user">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="user">Possible User</th>
                  <td mat-cell
                      *matCellDef="let element" style="padding: 5px;">
                    <app-user-card [firstName]="element.appUserMiniModel.firstName"
                                   [lastName]="element.appUserMiniModel.lastName"
                                   [displayName]="element.appUserMiniModel.email"
                                   [borderColor]="'transparent'"
                                   [sideColor]="'#345'"
                                   [image]="element.appUserMiniModel.imageUrl"
                    ></app-user-card>
                  </td>
                </ng-container>
                <!-- COLUMN -->
                <ng-container matColumnDef="number">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="number"> Phone Number</th>
                  <td mat-cell
                      *matCellDef="let element" style="padding: 5px;">
                    {{ element.delivery.destination }}
                  </td>
                </ng-container>
                <!-- COLUMN -->
                <ng-container matColumnDef="status">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="status"> Status</th>
                  <td mat-cell
                      *matCellDef="let element" style="padding: 5px;">
                    <span [appStatus]="element.status">{{ element.status }}</span>
                  </td>
                </ng-container>
                <!-- COLUMN -->
                <ng-container matColumnDef="message">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header="message"> Message</th>
                  <td mat-cell
                      *matCellDef="let element" style="padding: 5px;">
                    {{ element.delivery.providerResponse }}
                  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="['table-name','search-header']"></tr>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true;"></tr>
                <tr mat-row *matRowDef="let element; columns: columnsToDisplay;"
                    class="example-element-row">
                  <!--              (click)="expandedElement = expandedElement === element ? null : element">-->
                </tr>
                <!-- Row shown when there is no matching data. -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell" colspan="4">No data matching the filter.</td>
                </tr>
              </table>
            </div>
          </div>
          <mat-paginator style="background-color: white; z-index: 99;" [pageSizeOptions]="[100,250,500]"
                         aria-label="Select page of users"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

